export default "__VITE_ASSET__8e710f37__"